import { ReauthNeededInfo } from '../types'

export class ReauthNeededInfoSaver {
  readonly reauthNeededInfoKey = 'reauthNeededInfo'

  saveReauthNeededInfo(hasMeshfaClient?: boolean) {
    const path = window.location.pathname

    const reauthNeededInfo: ReauthNeededInfo = {
      path,
      hasMeshfaClient,
    }

    console.log('Saving reauth needed info:', JSON.stringify(reauthNeededInfo))

    localStorage.setItem(
      this.reauthNeededInfoKey,
      JSON.stringify(reauthNeededInfo),
    )
  }

  clearReauthNeededInfo() {
    localStorage.removeItem(this.reauthNeededInfoKey)
  }
}
